import { PRICE_POLICIES_GET_USER_ROLES_SUCCESS } from './constants'

import { takeEvery } from 'redux-saga/effects'
import { getRoleBonificationsSaga } from './getRoleBonifications/saga'

export default function* pricePolicies() {
    yield takeEvery(
        PRICE_POLICIES_GET_USER_ROLES_SUCCESS,
        getRoleBonificationsSaga
    )
}
